<script>
/**
 * ****************************************************************************
 * @description     :   Input Search Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash-uuid';
import { mapActions } from 'vuex';

import SamplePopupSearch from '@/views/popupSearch/samplePopupSearch';
import PopupSearchCertificates from '@/views/popupSearch/popupSearchCertificates';
import ra001700v from '@/views/inquiry/ra001700v';
import ra001800v from '@/views/inquiry/ra001800v';
import ra001900v from '@/views/inquiry/ra001900v';
import ra006400v from '@/views/inquiry/ra006400v';
import ra201000v from '@/views/inquiry/ra201000v';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input search component
 */
var FcInputSearch = {
    template: template,
    components: {
        SamplePopupSearch,
        PopupSearchCertificates,
        ra001700v,
        ra001800v,
        ra001900v,
        ra006400v,
        ra201000v
    },
    props: {
        id: String,
        label: String,
        index: String | Number,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        buttonClass: String,
        icon: {
            type: String,
            default: 'fas fa-search'
        },
        isShowClear: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: '参照して下さい'
        },
        value: String,
        modelValue: Object,
        initData: Object,
        pageSearch: String,
        propertyForId: String,
        propertyForName: String,
        popupName: String,
        isRequired: Boolean,
        isReadonly: {
            type: Boolean,
            default: true
        },
        isShowLabel: {
            type: Boolean,
            default: false
        },
        isDisabled: Boolean,
        isDisabledClear: Boolean,
        onChange: Function,
        onChangeInput: Function,
        size: String,
        maxLength: Number
    },
    emits: ['update:modelValue'],
    data() {
        return {
            newId: '',
            show: true
        };
    },
    mounted() {
        if (this.id && this.id != '') {
            this.newId = this.id;
        } else {
            this.newId = _.uuid();
        }
        const vm = this;
        let countLoop = 0;
        const interval = setInterval(function () {
            if (vm.$refs['popupSearch_' + vm.newId]) {
                vm.$refs['popupSearch_' + vm.newId].addEventListener(
                    'hidden.bs.modal',
                    vm.hidePopup
                );
                vm.$refs['popupSearch_' + vm.newId].addEventListener(
                    'show.bs.modal',
                    vm.showPopup
                );
                clearInterval(interval);
                // console.log(this.pageSearch, countLoop, 'added event');
            }
            if (countLoop > 100) {
                clearInterval(interval);
                // console.log('cannot add event');
            }
            countLoop++;
        }, 100);
    },
    unmounted() {
        this.hidePopup();
    },
    computed: {
        vewValue() {
            if (this.modelValue && this.modelValue[this.propertyName]) {
                return this.modelValue[this.propertyName];
            }
            return '';
        },
        propertyId() {
            if (this.propertyForId) {
                return this.propertyForId;
            }
            return 'code';
        },
        propertyName() {
            if (this.propertyForName) {
                return this.propertyForName;
            }
            return 'name';
        },
        modalTitle() {
            this.show = true;
            if (this.popupName) {
                return this.popupName;
            }
            /*eslint indent: [2, 4, {"SwitchCase": 1}]*/
            switch (this.pageSearch) {
                case 'ra001700v':
                    return '従業員の検索';
                case 'ra001800v':
                    return '１次会社検索';
                case 'ra001900v':
                    return '作業依頼内容の検索';
                case 'ra006400v':
                    return '１次会社通知先の選択';
                case 'ra201000v':
                    return '作業請負会社検索';
                default:
                    return '検索画面';
            }
        },
        realMaxLength() {
            return this.maxLength;
        }
    },
    methods: {
        ...mapActions('app', ['hideHeaderError']),
        /**
         * update value for input search
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(item) {
            if (this.onChange) {
                this.onChange(this.index, this.modelValue, item);
            } else {
                this.$emit('update:modelValue', item);
            }
        },
        /**
         * remove value for input search
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        clearInput() {
            if (this.onChange) {
                this.onChange(this.index, this.modelValue, null);
            } else {
                this.$emit('update:modelValue', null);
            }
        },
        hidePopup() {
            this.show = false;
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
        },
        showPopup() {
            this.show = true;
            if (this.hideHeaderError) {
                this.hideHeaderError();
            }
        },
        changeInput(e) {
            if (this.onChangeInput) {
                this.onChangeInput(this.index, e.target.value);
            }
        },
        /**
         * get max lenght input
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        getRealMaxLength() {
            // let maxl = this.maxLength;
            // if (maxl == undefined || maxl == null) {
            //     switch (this.pageSearch) {
            //         case 'ra001800v':
            //             maxl = 100;
            //             break;
            //         case 'ra001900v':
            //             maxl = 200;
            //             break;
            //         default:
            //             maxl = 50;
            //     }
            // }
            return undefined;
        }
    }
};
export default FcInputSearch;
</script>
